export default "__VITE_ASSET__CuBUymz1__"